// frontend/src/services/api.js
// WHY CHANGED:
//   - Added couponAPI for cancel / inactive / reactivate / audit

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Attach JWT to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (credentials) => api.post('/login', credentials),
};

export const customerAPI = {
  search:  (q)  => api.get('/customers/search', { params: { q } }),
  getById: (id) => api.get(`/customers/${id}`),
};

export const serviceAPI = {
  getByMembership: (membershipNo) => api.get(`/customer/services/${membershipNo}`),
  claimServices:   (payload)      => api.post('/services/claim', payload),
};

export const couponAPI = {
  cancel:     (payload) => api.post('/coupons/cancel',     payload),
  inactive:   (payload) => api.post('/coupons/inactive',   payload),
  reactivate: (payload) => api.post('/coupons/reactivate', payload),
  getAudit:   (membershipNo) => api.get(`/coupons/audit/${membershipNo}`),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export const uploadAPI = {
  uploadExcel: (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  },
};

export default api;